import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getData } from "./Services/api";
import { useNavigate } from "react-router-dom";


/* ================= MOBILE SUMMARY CARD ================= */

const MobileStatCard = ({ value, label, bg, onClick }) => (
  <div className="col-6 col-md-4 col-lg-4">
    <div
      className="card text-center shadow-sm h-100 border-0"
      style={{ cursor: "pointer", borderRadius: 14 }}
      onClick={onClick}
    >
      <div className="card-body py-3">

        <div
          className="rounded-circle mx-auto mb-2 d-flex align-items-center justify-content-center"
          style={{
            width: 56,
            height: 56,
            background: bg,
            fontWeight: "bold",
            fontSize: 18,
            color: "#2d3436"
          }}
        >
          {value}
        </div>

        <small className="text-muted fw-semibold">{label}</small>

      </div>
    </div>
  </div>
);


/* ================= HOME ================= */

const Home = () => {
  const [managers, setManagers] = useState([]);
  const [selectedManager, setSelectedManager] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [stats, setStats] = useState({
    actionSummary: {},
    beatPlanSummary: {}
  });

  const navigate = useNavigate();

  useEffect(() => {
    const storedUserStr = localStorage.getItem('user');
    if (storedUserStr) {
      try {
        const storedUser = JSON.parse(storedUserStr);
        if (storedUser?.role === 'accounts') {
          navigate('/accounts-dashboard/view-edit', { replace: true });
        }
      } catch (e) {}
    }
  }, [navigate]);


  const goToReport = (module, type) => {
    navigate(
      `/${module}/list?manager=${selectedManager}&from=${fromDate}&to=${toDate}&type=${type}`
    );
  };


  /* ===== FETCH MANAGERS ===== */
  useEffect(() => {
    const fetchManagers = async () => {
      const res = await getData("/users/getAllManager-admin");
      if (res?.success) setManagers(res.data || []);
    };
    fetchManagers();
  }, []);

  /* ===== FETCH DASHBOARD ===== */
  useEffect(() => {
    if (!selectedManager) return;

    const fetchStats = async () => {
      const url = `/dashboard/manager-home?manager_id=${selectedManager}&from=${fromDate}&to=${toDate}`;
      const res = await getData(url);

      if (res?.success) {
        setStats(res); // ✅ IMPORTANT
      }
    };

    fetchStats();
  }, [selectedManager, fromDate, toDate]);

  return (
    <div className="pc-container">
      <div className="pc-content">

        {/* ===== HEADER ===== */}
        <div className="page-header mb-3">
          <div className="row align-items-center">
            <div className="col-md-12">
              <ul className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                <li className="breadcrumb-item active">Dashboard</li>
              </ul>
            </div>

            <div className="col-md-12 d-flex justify-content-between align-items-center">
              <h2 className="mb-0">Reports Dashboard</h2>

              <div className="d-flex gap-2">
                <select
                  className="form-select"
                  value={selectedManager}
                  onChange={(e) => setSelectedManager(e.target.value)}
                >
                  <option value="">Select Manager</option>
                  {managers.map((m) => (
                    <option key={m.id} value={m.id}>
                      {m.username}
                    </option>
                  ))}
                </select>

                <input
                  type="date"
                  className="form-control"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />

                <input
                  type="date"
                  className="form-control"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>

        {/* ===== DASHBOARD ===== */}
        {selectedManager ? (
  <>
    {/* ===== ACTION SUMMARY ===== */}
    <h5 className="mb-3">Action Summary</h5>

    <div className="row g-3 mb-4">

      <MobileStatCard
        value={stats.actionSummary?.totalCalls || 0}
        label="Total Call"
        bg="#b7e4c7"
        onClick={() => goToReport("call-log", "total")}
      />

      <MobileStatCard
        value={stats.actionSummary?.orderCall || 0}
        label="Order Received"
        bg="#ffc9c9"
        onClick={() => goToReport("call-log", "order")}
      />

      <MobileStatCard
        value={stats.actionSummary?.collectionCall || 0}
        label="Collection Call"
        bg="#ffeaa7"
        onClick={() => goToReport("call-log", "collection")}
      />

      <MobileStatCard
        value={stats.actionSummary?.totalVisit || 0}
        label="Total Visit"
        bg="#c7e0f4"
        onClick={() => goToReport("visit-log", "total")}
      />

      <MobileStatCard
        value={stats.actionSummary?.orderVisit || 0}
        label="Order Received"
        bg="#e0c3fc"
        onClick={() => goToReport("visit-log", "order")}
      />

      <MobileStatCard
        value={stats.actionSummary?.collectionVisit || 0}
        label="Collection Visit"
        bg="#c3f7df"
        onClick={() => goToReport("visit-log", "collection")}
      />

    </div>

    {/* ===== BEAT PLAN SUMMARY ===== */}
    <h5 className="mb-3">Beat Plan Summary</h5>

    <div className="row g-3 mb-4">

      <MobileStatCard
        value={stats.beatPlanSummary?.totalPlan || 0}
        label="Total Plan"
        bg="#c3f7df"
        onClick={() => goToReport("beat", "total")}
      />

      <MobileStatCard
        value={stats.beatPlanSummary?.completedPlan || 0}
        label="Completed Plan"
        bg="#d6e4ff"
        onClick={() => goToReport("beat", "completed")}
      />

    </div>
  </>
) : (
  <p className="text-center mt-5">Please select a manager</p>
)}
      </div>
    </div>
  );
};

export default Home;
